
    export default {
      name: "cal-cart-page-banner",
      props: ["sliderData"],
      methods:{
        handleClick() {
      if (this.sliderData.button_path.startsWith("$")) {
        this.emitCustomEvent({ type: this.sliderData.button_path, data: "" });
      } else if (this.sliderData.button_path.startsWith("https")) {
        window.open(this.sliderData.button_path, '_blank');
      } else {
        this.$router.push(`/${this.$i18n.locale}/${this.sliderData.button_path}`);
      }
    },
      }
    }
